import React from 'react';

import {
    isCommunitiesAllowed,
    isCommunityTemplatesAllowed,
    isCommunitiesFeatureEnabled,
    isHideCommunityCreationFeatureEnabled,
} from '@lumapps/communities/ducks/selectors';
import type { SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { useSelector } from '@lumapps/redux/react';
import { createSelector } from '@lumapps/redux/reselect';

import { CommunitiesSideNavigation as CommunitiesSideNavigationUI } from './CommunitiesSideNavigation';

const stateSelector = createSelector(
    [
        isCommunitiesAllowed,
        isCommunityTemplatesAllowed,
        isCommunitiesFeatureEnabled,
        isHideCommunityCreationFeatureEnabled,
    ],
    (isAllowed, isTemplatesAllowed, isFeatureEnabled, isCommunityCreationHidden) => ({
        isAllowed: isAllowed && isFeatureEnabled && !isCommunityCreationHidden,
        isTemplatesAllowed: isTemplatesAllowed && isFeatureEnabled && !isCommunityCreationHidden,
    }),
);

export const CommunitiesSideNavigation: React.FC<Partial<SideNavigationItemProps>> = (props) => {
    const { isAllowed, isTemplatesAllowed } = useSelector(stateSelector);

    return <CommunitiesSideNavigationUI {...props} isAllowed={isAllowed} isTemplatesAllowed={isTemplatesAllowed} />;
};

CommunitiesSideNavigation.displayName = 'SideNavigationItem';
